const $ = jQuery.noConflict();

'use strict';
const ResetPassword = {

	// properties
	$domForm: null,
	$domSubmit: null,
	$domResponse: null,

	// initialize
	init: function() {
		if ($('.js-reset-password').length === 0) {
			return;
		}
		$('.js-response-reset').hide();
		this.initDom();
		this.bindEvents();
		this.updateSubmitButton();
	},

	// set $dom variables
	initDom: function() {
		ResetPassword.$domForm = $('.js-reset-password__form');
		ResetPassword.$domSubmit = ResetPassword.$domForm.find('.js-reset-password--btn');
		ResetPassword.$domResponse = ResetPassword.$domForm.find('.js-response-reset');
	},

	// attach events
	bindEvents: function() {
		// intercept submission
		ResetPassword.$domForm.on('submit', function() {
			const destiny = ResetPassword.validateForm();
			if (destiny === true) {
				ResetPassword.sendRequest();
			} else {
				$('.js-response-reset').show();
				ResetPassword.responseMessage(destiny, true);
			}
			return false; // always reject
		});
		// inputs
		ResetPassword.$domForm.find('input').on('input change', function(){
			ResetPassword.updateSubmitButton();
		});
		// btn
		ResetPassword.$domSubmit.on('click', function(e) {
			e.preventDefault();
			ResetPassword.$domForm.trigger('submit');
		});
	},

	// check form content
	validateForm: function() {
		const form = ResetPassword.$domForm.serializeArray();
		// first field is required
		if (form[0].value === '') {
			return 'Email field is required';
		}
		return true;
	},

	// update state of "submit" button
	updateSubmitButton: function() {
		ResetPassword.$domSubmit.toggleClass('btn-disabled', ResetPassword.validateForm() !== true);
	},

	// send form submission
	sendRequest: function() {
		ResetPassword.$domSubmit.addClass('btn-disabled');
		$('.js-response-reset').show();
		ResetPassword.responseMessage('');
		const formValues = ResetPassword.$domForm.serializeArray();
		formValues.push({name: 'action', value: 'reset-password'});
		// dispatch request
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: formValues,
			success: function(response) {
				$('.js-response-reset').show();
				if (response.success === undefined) {
					const email = $('.js-email-reset-password').val().trim();
					ResetPassword.responseMessage(`<span>${email}</span> is not associated with an account`, true);
				}
				if (response.success === false) {
					if (!response.data.message) {
						ResetPassword.responseMessage(response.data.html, true);
					} else {
						ResetPassword.responseMessage(response.data.message, true);
					}
				}
				if (response.success === true) {
					ResetPassword.clearForm();
					ResetPassword.responseMessage('The email has been sent. Go to your email to set a new password.', false);
					// window.location.href = window.location.origin;
				}
			},
			complete: function() {
				ResetPassword.$domSubmit.removeClass('btn-disabled');
			}
		});
	},

	// display message
	responseMessage: (msg, asError) => {
		ResetPassword.$domResponse
			.html(msg)
			.toggleClass('error-wrap', msg !== '' && asError);
	},

	// empty inputs
	clearForm: function() {
		ResetPassword.$domForm.find('input').val('');
		ResetPassword.updateSubmitButton();
	},

};

export default ResetPassword;
